import { useAppStore } from '@src/app/context'
import type { IFlagsService } from '@src/service/feature-flags'

export default function useFlags(): IFlagsService {
  const app = useAppStore()

  return app.service.flags
}
